export enum Origin {
    VIDEOBLOCKS = 'VIDEOBLOCKS',
    AUDIOBLOCKS = 'AUDIOBLOCKS',
    GRAPHICSTOCK = 'GRAPHICSTOCK',
    STORYBLOCKS = 'STORYBLOCKS',
    STORYBLOCKS_NEXTJS = 'STORYBLOCKS_NEXTJS',
    CONTRIBUTOR_PORTAL = 'CONTRIBUTOR_PORTAL',
    TEMPLATE_EDITOR = 'TEMPLATE_EDITOR',
    ACCOUNT_SERVICE = 'ACCOUNT_SERVICE',
    BILLING_SERVICE = 'BILLING_SERVICE',
    CONTENT_SERVICE = 'CONTENT_SERVICE',
    PAYOUT_SERVICE = 'PAYOUT_SERVICE',
    TRANSLATION_SERVICE = 'TRANSLATION_SERVICE',
    CONTENT_RATING_APP = 'CONTENT_RATING_APP',
    FEATURE_FLAG_SERVICE = 'FEATURE_FLAG_SERVICE',
    PREMIERE_PRO_PLUGIN = 'PREMIERE_PRO_PLUGIN',
    AFTER_EFFECTS_PLUGIN = 'AFTER_EFFECTS_PLUGIN',
    EXAMPLE_SERVICE = 'EXAMPLE_SERVICE',
    SEARCH_SERVICE = 'SEARCH_SERVICE',
    CONTENT_JOB = 'CONTENT_JOB',
    DATA_JOB = 'DATA_JOB',
    MISC = 'MISC',
    STORYBOARD = 'STORYBOARD',
    OUTDATED_SCHEMA = 'OUTDATED_SCHEMA',
}